import { useCallback } from "react";

import type { DiscountOrdinaryInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { DISCOUNT_ORDINARY_FOR_ORDINARY_UPDATE_MUTATION } from "./schema";

type Props = {
	onResetViewModel: () => void;
};

export const useDiscountOrdinaryUpdateMutation = ({ onResetViewModel }: Props) => {
	const { mutationFunc } = useCustomMutation(DISCOUNT_ORDINARY_FOR_ORDINARY_UPDATE_MUTATION);
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const onUpdateDiscountOrdinary = useCallback(
		async (input: DiscountOrdinaryInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { input },
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "通常ディスカウントを更新しました",
				});
				onResetViewModel();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, onResetViewModel, showLoadingScreenCallback],
	);

	return {
		onUpdateDiscountOrdinary,
	};
};
